import i18nFactory from '@yandex-int/i18n';
import { Epic } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';

import { Action } from '../../../actions';
import {
    ApproveCooperationByClientAction,
    REQUEST_COOP_BY_CUSTOMER_START,
    requestCooperationByClientError,
    requestCooperationByClientSuccess
} from '../../../actions/freelancers/freelancer-accept-popup';
import { freelancerCardUpdateCustomerPhone } from '../../../actions/freelancers/freelancer-card';
import { mapRequestFlServiceByClientResponse } from '../../../mappers/freelancers';
import { showNoticeMessage } from '../../../service/GridHelpers/GridHelpers';
import { EpicDeps } from '../../../service/StoreFactory';
import { NoticeType } from '../../../typings/grid';
import { State } from '../../../typings/state';

import * as keyset from './freelancer-accept-popup.i18n';

const i18n = i18nFactory(keyset);

export const requestCooperationByClientEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(REQUEST_COOP_BY_CUSTOMER_START).mergeMap(
        (action: ApproveCooperationByClientAction): Observable<Action> => {
            return Observable.fromPromise(
                deps.freelancerMutationExecutor.updateUserPhone({
                    phone: action.editPhone
                })
            )
                .mergeMap(() => {
                    const updatePhoneAction$ =
                        action.editPhone.trim() !== action.originPhone.trim()
                            ? of(freelancerCardUpdateCustomerPhone(action.editPhone))
                            : EMPTY;

                    return Observable.concat(
                        updatePhoneAction$,
                        Observable.fromPromise(
                            deps.freelancerMutationExecutor.requestFlServiceByClient({
                                input: {
                                    freelancerId: action.freelancerId
                                }
                            })
                        )
                            .map(response => mapRequestFlServiceByClientResponse(response))
                            .mergeMap(data => {
                                return Observable.of(requestCooperationByClientSuccess(data)).do(() =>
                                    showNoticeMessage(NoticeType.success, i18n('success-cooperation-request'))
                                );
                            })
                    );
                })
                .catch(
                    (): Observable<Action> => {
                        showNoticeMessage(NoticeType.error, i18n('error-refresh'));
                        return Observable.of(requestCooperationByClientError());
                    }
                );
        }
    );
};
